export default class Cashback {
    constructor (
      _id = 1,
      _amount = "", 
      _month = {}, 
      _customer = "",
      _status = { code: 8, name: 'Pendiente Pago' }
    ){
      this.id       = _id
      this.amount   = _amount;
      this.month    = _month;
      this.customer = _customer;
      this.status   = _status;
    }
}
  